/** Kept in lockstep with package.json by src/__tests__/version.test.ts. Not exported: the header is the only reader. */
export const SDK_NAME = 'plugin-sdk' as const;
export const SDK_VERSION = '4.5.0' as const;
